import store from "@/store";
import { removeToken } from "@/utils/auth";
// import moment from "moment";
import { callApi } from "@/api/others";
import { encryptor, decryptor } from "@/utils/encryptor";
import dayjs from "dayjs";
export const mainMixins = {
  data: function() {
    return {
      devWidth: 1000,
      devHeight: window.innerHeight - 57,
      actualDevHeight: window.innerHeight,
      actualDevWidth: window.innerWidth,
      devWidth2: window.innerWidth - 50,
      devHeight2: window.innerHeight-80,
      dpLoading: false,
      adaptiveLabel: "",
      localSubmitUrl: this.SubmitUrl,
      masterUnits: {
        ML: "0172a76d-3b5a-41ce-83d7-9cb5cec7c405",
        Nos: "0172a76b-db71-431d-8d6f-50d5e56357e9",
        Peg: "0172a76b-b848-4d48-b278-5c072ef79365",
      },
    };
  },
  watch: {
    dpLoading(newValue, oldValue) {
      newValue == true
        ? (this.$root.$children[0].isLoading = true)
        : (this.$root.$children[0].isLoading = false);
    },
  },

  beforeRouteEnter(to, from, next) {
    // use this as mounted
    // console.log(result1);
    next((vm) => {
      // 1.>  check for token, else logout
      var t = localStorage.getItem(btoa("Admin-Token"));
      if (!t) {
        removeToken("Admin-Token");
        store.commit("SET_TOPBARSHOW", false);
        store.commit("SET_BOTTOMNAVSHOW", false);
        store.commit("SET_LOGGEDOUT", true);
      }
      // end check for token.
    });
  },

  methods: {
    // capitalise first letter
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    setFromBelongs(belongs) {
      this.fromBelongs = belongs;
    },
    setToBelongs(belongs) {
      this.toBelongs = belongs;
    },
    // to convert date
    // convertTheDate(d) {
    //   if (d==null || d==undefined){return "-"}
    //   return moment(d).format("YYYY-MM-DD");
    // },
    normaliseDate(d){
      if (d==null || d==undefined){return "-"}
      return dayjs(d).format("DD-MM-YYYY");
    },
    // now() {
    //   return moment().format("YYYY-MM-DD");
    // },
    // format currency as INR
    formatCurrency(c) {
      return new Intl.NumberFormat("en-IN", {
        maximumSignificantDigits: 3,
      }).format(c);
    },
    formatNumber(amount) {
      if (amount != null && amount !== "") {
        return amount.toLocaleString("en-IN", {
          maximumFractionDigits: 3,
          minimumFractionDigits: 2,
          style: "decimal",
        });
      } else return "0.00";
    },
    encryptIt(str, lsName, rotv) {
      encryptor(str, lsName, rotv);
    },
    // to decrypt
    decryptIt(lsName, rotv) {
      return decryptor(lsName, rotv);
    },
    encryptMobNo(mobNo){
      return encryptor(mobNo,btoa(btoa(btoa("mobno"))), 19);
    },
    decryptMobNo(){
      return decryptor(btoa(btoa(btoa("mobno"))), -19);
    },
    encryptMemId(memberId){
      return encryptor(memberId,btoa("memberId"), 19);
    },
    decryptMemId(){
      return decryptor(btoa("memberId"), -19);
    },
    //Call this function to decrypt
    GetItem(key) {
      var orgKey = btoa(key);
      var key2 = this.decryptIt(orgKey, -19);
      return key2;
    },
    getSettings: async function(fmodule, fsubmodule, fsetting, currentpage) {
      var common = currentpage.$refs.common;
      var self = this;
      this.settingsQModel = {
        module: fmodule,
        submodule: fsubmodule,
        setting: fsetting,
        value: null,
      };
      var url = "/api/wesupport/GeneralMaster/getSettings";
      await callApi(url, "post", self.settingsQModel)
        .then((response) => {
          self.settingsQModel.value = response.data.data;
        })
        .catch((error) => {
          common.ManageResponse(error.response);
        });
    },
  },
};
